import { createThemeOptions } from '@cloudquery/cloud-ui';

import { createTheme as createMuiTheme } from '@mui/material/styles';

import type {} from '@mui/x-data-grid/themeAugmentation';

const cloudUITheme = createThemeOptions();

export const theme = createMuiTheme(cloudUITheme, {
  components: {
    MuiDataGrid: {
      styleOverrides: {
        cellCheckbox: {
          paddingLeft: 8,
        },
        columnHeaderCheckbox: {
          width: '58px !important',
        },
        columnHeaderRow: {
          backgroundColor: `${cloudUITheme.palette?.background?.paper} !important`,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        sizeSmall: {
          top: '-4px',
        },
      },
    },
  },
  palette: {
    ...cloudUITheme.palette,
    DataGrid: {
      headerBg: cloudUITheme.palette?.background?.paper,
      rowBorderColor: cloudUITheme.palette?.divider,
    },
    background: {
      ...cloudUITheme.palette?.background,
      primaryGradient:
        'radial-gradient(448.37% 145.41% at 5.38% 50%, rgba(9, 117, 141, 0.90) 0%, rgba(6, 174, 212, 0.90) 100%)',
      secondaryGradient:
        'radial-gradient(1326.51% 232.98% at -65.82% 15.14%, rgba(7, 103, 83, 0.90) 0%, rgba(23, 178, 100, 0.90) 100%)',
      tertiaryGradient:
        'radial-gradient(1326.51% 232.98% at -65.82% 15.14%, rgba(151, 70, 24, 0.90) 0%, rgba(205, 94, 31, 0.90) 100%)',
    },
    primary: {
      ...cloudUITheme.palette?.primary,
      selected: 'rgba(23, 178, 100, 0.12)',
    },
  },
});
